exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#solution-database-form .form-title {\n  font-weight: 500;\n  font-size: large;\n  padding: 0 0 5px 0;\n  margin: 0; }\n\n#solution-database-form .solution-field {\n  width: 98%; }\n\n.hidden {\n  display: none; }\n\n#solution-button-view {\n  margin-bottom: 5px; }\n\n.view-table-button {\n  padding-right: 10px; }\n\n.main-layer {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n.log-btn {\n  width: 169px;\n  margin-right: 1%;\n  margin-top: -32px;\n  margin-bottom: 2%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-form/solution-description-form.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description-form/solution-description-form.component.scss
// module chunks = main